import axios from "axios";

// In-memory cache for agent profiles by senderId
const agentCache = new Map();
const pendingRequests = new Map();

/**
 * Fetch agent information from auth microservice by senderId.
 * Caches in memory and deduplicates in-flight requests.
 */
export const getAgentInfoById = async (senderId) => {
  if (!senderId || typeof senderId !== "string") return null;

  if (agentCache.has(senderId)) {
    return agentCache.get(senderId);
  }

  if (pendingRequests.has(senderId)) {
    return await pendingRequests.get(senderId);
  }

  const fetchPromise = (async () => {
    try {
      const authUrl =
        process.env.REACT_APP_AUTH_MICROSERVICE_URL ||
        "https://auth-stg.dexkor.com/api/v1";

      const response = await axios.get(`${authUrl}/users/${senderId}`);
      if (response && response.data) {
        const user = response.data;
        const details = {
          id: user._id || senderId,
          name: user.name || user.username || (user.email ? user.email.split("@")[0] : "Support Agent"),
          email: user.email || "",
          avatar:
          user.image ||
          user.profilePic ||
          user.profilePicture ||
          user.avatar ||
            user.profileImage ||
            null,
          initials: (user.name
            ? user.name
                .split(" ")
                .map((p) => p[0])
                .join("")
            : "A"
          )
            .toUpperCase()
            .substring(0, 2),
        };
        agentCache.set(senderId, details);
        return details;
      }
    } catch (err) {
      console.warn("Could not fetch agent info for senderId:", senderId, err.message);
    } finally {
      pendingRequests.delete(senderId);
    }
    return null;
  })();

  pendingRequests.set(senderId, fetchPromise);
  return await fetchPromise;
};

/**
 * Synchronous lookup in cache (returns null if not fetched yet).
 */
export const getCachedAgentInfo = (senderId) => {
  if (!senderId) return null;
  return agentCache.get(senderId) || null;
};
